import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { motion } from "framer-motion";
import Stats from '../component/Stats';
import Process from '../component/Process';
import Faq from '../component/Faq';
import Calltoaction from '../component/Calltoaction';
import Eligibilityandoc from '../component/Eligibilityandoc';
import insServiceThum from '../assets/instanceThum.png'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';


export default function InstantLoan() {
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2,
      },
    },
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };
  const cardHover = {
    y: -6,
    boxShadow: "0px 20px 40px rgba(0,255,255,0.08)",
    transition: { duration: 0.3 },
  };

  const features = [
    "Minimal Documentation",
    "100% Online Verification",
    "Transparent Loan Terms",
    "Faster Eligibility-Based Processing",
  ];



  return (
    <>
      <Header />
      {/* banner section start */}
      <div className="relative h-[300px] flex items-center justify-center bg-gradient-to-br from-[#0b1f3a] to-[#0a2540] overflow-hidden">
        {/* Animated Background Glow */}
        <div className="absolute w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl animate-pulse top-[-100px] left-[-100px]" />
        <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-80px] right-[-80px]" />

        {/* Glass Card */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="px-10 py-8 text-center "
        >
          {/* Title */}
          <motion.h1
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
            className="text-4xl md:text-5xl font-bold text-white"
          >
            Instant <span className="text-orange-400">Loan</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="mt-4 text-gray-200 text-sm md:text-base"
          >
            Support for Short-Term Financial Needs Before personal loan
            {/* <span className="text-orange-400 font-semibold">
              Your Ambitions
            </span> */}
          </motion.p>
        </motion.div>
      </div>
      {/* end */}

      {/* service Intro section  */}
      <section className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <p className="text-gray-700 leading-7 mb-6">
              <span className="font-semibold">B4SALARY</span> helps salaried professionals navigate temporary financial gaps through a simple digital 
              process with minimal documentation, online verification, and a transparent lending experience. 
              Loans are facilitated through our RBI-registered NBFC partner - Kisga Leasing and Finance Pvt. Ltd.</p>

            {/* FEATURES */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {features.map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <CheckCircleIcon className="text-orange-500 w-5 h-5" />
                  <span className="text-gray-800 text-sm font-medium">
                    {item}
                  </span>
                </div>
              ))}
            </div>

            {/* BUTTON */}
            <Link to={'/apply-now'}>
              <button className=" cursor-pointer bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full shadow-md transition-all duration-300 hover:scale-105">
                Apply Instantly
              </button>
            </Link>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className=""
          >
            <div className="">
              <img
                src={insServiceThum}
                alt="Loan"
                className=""
              />


            </div>
          </motion.div>

        </div>
      </section>
      {/* end */}


      <Process />
      <Eligibilityandoc />
      <Calltoaction />
      <Stats />
      <Faq />





      <Footer />
    </>
  )
}
